import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "tw-inline-flex tw-flex-1"
};
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: 'SfDropdownItemHeader'
    },
    __name: 'sf-dropdown-item-header',
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _mergeProps({
                class: "sf-dropdown2-item tw-bg-sf-snow-dark tw-text-sf-gray-light hover:tw-text-sf-gray-light tw-text-[11px] tw-uppercase tw-font-medium tw-text-xs !tw-cursor-default tw-py-2 tw-px-4 sf-nowrap",
                "data-testid": "dropdown-item-header"
            }, _ctx.$attrs, {
                onClick: _cache[0] || (_cache[0] = _withModifiers(()=>{}, [
                    "stop",
                    "prevent"
                ]))
            }), [
                _createElementVNode("span", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "icon"),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 16);
        };
    }
});
